const refs = {
  // This is overwritten from the feature-consent module
  useObserveCMPBannerVisibility: () => {},
};

export default refs;
